/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTimeOld(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (!time) {
    return ''
  }
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
    if (date == null) {
      // date=new Date();
      return null
    }
  } else {
    if ((typeof time === 'string')) {
      time = time.replace('/Date(', '').replace(')/', '')
      if ((/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      } else {
        time = time.replace(/-/g, '/').replace(/T|Z/g, ' ').trim()
      }
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 * 将报文中的日期(MMddHHmm)转换为绑定到日期空间中的值(yyyy-MM-dd HH:mm)
 */
export function formatTimeM(time, option) {
  if (('' + time).length === 8) {
    const now = new Date()
    const resTime = new Date(now.getFullYear(), time.slice(0, 2) - 1, time.slice(2, 4), time.slice(4, 6), time.slice(6, 8), 0)
    return resTime
  } else {
    return time
  }
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 * 将绑定到日期空间中的值(yyyy-MM-dd HH:mm)转换为报文中的日期(MMddHHmm)
 */
export function formatTimeMV(time, option) {
  let date = new Date()
  if (!time) {
    date = new Date(time)
  }
  return '' + date.getMonth() + '' + date.getDay() + '' + date.getHours() + '' + date.getMinutes()
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

//判断是否为非空，排除0、0.0 0.00等，空返回false,非空包含0返回true
export function IsNotEmptyStr(str) {
  if(!str){
    var f_x = parseFloat(str);
    if (isNaN(f_x)) {
      return false;
    }
    return true;
  }
  else{
    return true;
  }
}


//float 类型的保留x位小数位
export function DataFormat(floatvar, Digit) {
  var f_x = parseFloat(floatvar);
  if (isNaN(f_x)) {
      return floatvar;
  }
  f_x = Math.round(f_x * Math.pow(10, Digit)) / Math.pow(10, Digit);
  var s_x = f_x.toString();
  var pos_decimal = s_x.indexOf('.');
  if (pos_decimal < 0) {
      pos_decimal = s_x.length;
      s_x += '.';
  }
  while (s_x.length <= pos_decimal + Digit) {
      s_x += '0';
  }
  return s_x;
}

// 保留三位有效数字
export function VailFormat(value, len) {
  var bnum = 1000000000000000;
  if (isNaN(value)) {
    return value;
  }
  //if (value > 2000) {
  //    value = 1000;
  //}
  var num = parseInt(value * bnum);
  var numlen = num.toString().length;
  var res = num.toString().substr(0, len + 1);
  var resnum = Math.round(res / 10);
  var bnum10 = Math.pow(10, numlen - len);
  var result = resnum * bnum10 / bnum;

  //补0
  if (result.toString().substr(0, 1) == "0" && result.toString().indexOf(".") >= 0) {
      var zerocnt = 2;
      while (result.toString().substr(zerocnt, 1) == "0") {
          zerocnt++;
      }
      //0开头有小数点

      while (result.toString().length < (len + zerocnt)) {
          result = result + "0";
      }
  }
  else if (result.toString().indexOf(".") >= 0) {
      //有小数点
      while (result.toString().length < (len + 1)) {
          result = result + "0";
      }
  } else {
      //没有小数点

      var zerocnt = len - result.toString().length;
      var zerostr = "";
      while (zerocnt > 0) {
          zerostr += "0";
          zerocnt--;
      }
      if (zerostr.length > 0) {
          result += "." + zerostr;
      }
  }
  return result;
}

/**
 * 给表头添加提示信息
 */
export function renderHeader(h, { column }) {
  return h(
    'el-tooltip', //  标签的名称
    {
      props:
       { // 标签的参数　通过不同的标签 显示不同的文字
         content: (function() {
           // 如何拿到 label的文字？？ 通过column.label来拿
           const label = column.label
           return label
           // switch (label) {
           //   case '拦截状态':
           //     return '我是提示文字'
           //     break
           //   case '提示2':
           //     return '提示文字2'
           //     break
           //   case '提示3':
           //     return '提示文字3'
           //     break
           // }
         })(),
         placement: 'top'
         // effect: "light",  //  默认为黑色主题
       },
      // /下面的意思是往el-tooltip　标签里面添加内容　column.label（拿到自己定义的显示内容：　拦截状态　）
      domProps: {
        // innerHTML: column.label +  '<span class="el-icon-question" style="color: #409eff;margin-left:10px "></span>'
        innerHTML: column.label + '<span  style="color: #409eff;margin-left:10px "></span>'
      }
    },
    [h('span')]
  )
}
/* 中英文长度*/
export function validateTextLength(value) {
  // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
  const cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
  const mat = value.match(cnReg)
  let length = 0
  if (mat) {
    return (length = mat.length * 2 + (value.length - mat.length) * 1)
  } else {
    return (length = value.length * 1)
  }
}


/*数组按对象属性排序 */
export function compare(property){
  return function(a,b){
      var value1 = a[property];
      var value2 = b[property];
      //return value1 - value2;
      return value1 > value2 ? 1 : -1;//时间
  }
}

/*数组按对象属性排序 */
export function compareNumber(property){
  return function(a,b){
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;//typeof time === 'number'
  }
}

/*数组按对象属性排序-倒序排序 */
export function compareDesc(property){
  return function(a,b){
      var value1 = a[property];
      var value2 = b[property];
      //return value2 - value1;
      return value1 < value2 ? 1 : -1;
  }
}

/*数组按对象属性排序 ['a','b','c'] */
export function compareMore(property){
  return function(a,b){
      for(let i=0,len=property.length;i<len,i++;)
      {
        let prop=property[i];
        if(parseInt(a[prop]) > parseInt(b[prop]))
        {
          return 1;
        }
        else if(parseInt(a[prop]) < parseInt(b[prop]))
        {
          return -1;
        }
      }
      return -1;
  }
}


/*数组按对象属性排序-倒序 ['a','b','c'] */
export function compareMoreDesc(property){
  return function(a,b){
      for(let i=0,len=property.length;i<len,i++;)
      {
        let prop=property[i];
        if(parseInt(a[prop]) > parseInt(b[prop]))
        {
          return -1;
        }
        else if(parseInt(a[prop]) < parseInt(b[prop]))
        {
          return 1;
        }
      }
      return 1;
  }
}

/**
 * 拼接对象为请求字符串
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 * Auth:WANGJIAN
 */
export function encodeSearchParams(obj) {
  const params = []

  Object.keys(obj).forEach((key) => {
    let value = obj[key]
    // 如果值为undefined我们将其置空
    if (typeof value === 'undefined') {
      value = ''
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join('='))
  })

  return params.join('&')
}
